import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FilingService {

	constructor(
		private http: HttpClient
	) { }
	
	async getFoldersForCategory(cid: string, scid: string, open: boolean = true, showall: boolean = true): Promise<any> {
		let url = `/aw-server/rest/recordsmanagement/fpfolders/category/for?`;
		url += `&category=${encodeURIComponent(cid)}`;
		url += `&subcategory=${encodeURIComponent(scid)}`;
		url += `&isOpen=${open}`;
		url += `&defaultAll=${showall}`;

		try {
			const response = await firstValueFrom(this.http.get<any>(url, {}));

			if (response) {
				let result = Object.keys(response).map(key => ({id: Number(key), name: response[key]}));	
				return result;
			} else {
				return Promise.reject(false);
			}
		} catch (error) {
			return Promise.reject(error);
		}
	}	
	
	async getRecordForProduct(prodid: number, isExtendedView: boolean): Promise<any> {
		let url = `/aw-server/rest/recordsmanagement/records/product/${prodid}`;
		if (isExtendedView) {
			url = `/aw-server/rest/recordsmanagement/records/extended/product/${prodid}`;
		}
	
		try {
			return await firstValueFrom(this.http.get<any>(url, {}));
		} catch (error) {
			return Promise.reject(error);
		}
	}

	/**
	 * Sets the filing completion status.
	 * Accepts either record or product ids.
	 */
	async updateRecordCompleteStatus(ids: any[], completed: boolean = false, doToggle: boolean = false): Promise<any> {
		let url = `/aw-server/rest/recordsmanagement/action/mass/update/records/complete?completed=${completed}`;
		if (doToggle) {
			url = `/aw-server/rest/recordsmanagement/action/mass/update/records/complete/toggle`;
		}
	
		try {
			return await firstValueFrom(this.http.post<any>(url, ids));
		} catch (error) {
			return Promise.reject(error);
		}
	}

	async fileRecords(ids: any[], rmData: any = {}): Promise<any> {
		rmData.productIds = ids;
		
		var url = '/aw-server/rest/recordsmanagement/action/products/records/file';
	
		try {
			return await firstValueFrom(this.http.post<any>(url, rmData));
		} catch (error) {
			return Promise.reject(error);
		}
	}
}
